var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-container buy-plugin"},[(_vm.loading)?_c('status-message',{staticClass:"tw-h-full",attrs:{"message":_vm.statusMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }